import { Controller } from 'react-hook-form';
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText
} from '@mui/material';

const RadioButtonRHF = ({
  name,
  control,
  label,
  required = false,
  options = [],
  row = true,
  disabled = false,
  sx = {}
}) => {
  const labelWithAsterisk = label ? required ? `${label} *` : label : '';

  return (
    <FormControl component="fieldset" sx={sx}>
      <FormLabel component="legend">{labelWithAsterisk}</FormLabel>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <>
            <RadioGroup
              {...field}
              row={row}
              onChange={(e) => field.onChange(e.target.value)}
            >
              {options.map((option) => (
                <FormControlLabel
                  key={option.value}
                  value={option.value}
                  control={<Radio disabled={disabled} />}
                  label={option.label}
                />
              ))}
            </RadioGroup>
            {error && <FormHelperText error>{error.message}</FormHelperText>}
          </>
        )}
      />
    </FormControl>
  );
};

export default RadioButtonRHF;
